module.exports = __webpack_public_path__ + "img/answer-c2-3.bd02c12b.png";